var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
export var getHelpVideosData = function (page, channelId, selectedLang) { return ({
    query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query($page: String!, $lang: String!, $channelId: String!) {\n    helpVideos(page: $page, lang: $lang, channelId: $channelId)\n      @rest(type: \"GetHelpVideos\", path: \"/getHelpVideos?page=:page&lang=:lang", "\", endpoint: \"query\") {\n        featuredVideo\n        videos\n    }\n  }\n"], ["\n  query($page: String!, $lang: String!, $channelId: String!) {\n    helpVideos(page: $page, lang: $lang, channelId: $channelId)\n      @rest(type: \"GetHelpVideos\", path: \"/getHelpVideos?page=:page&lang=:lang", "\", endpoint: \"query\") {\n        featuredVideo\n        videos\n    }\n  }\n"])), channelId ? '&channelId=:channelId' : ''),
    variables: channelId
        ? {
            page: encodeURIComponent(page),
            lang: selectedLang || localStorage.getItem('lang'),
        }
        : {
            page: encodeURIComponent(page),
            channelId: channelId,
            lang: selectedLang || localStorage.getItem('lang'),
        },
}); };
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/getHelpVideo.ts
// module id = 2034
// module chunks = 81